import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=e0b257b8&scoped=true"
import script from "./Supplies.vue?vue&type=script&lang=js"
export * from "./Supplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b257b8",
  null
  
)

export default component.exports